function makeSafeFilename(name) {
    return String(name)
        .trim()
        .replace(/[\/\\?%*:|"<>]/g, '-')
        .replace(/\s+/g, ' ')
}

export {
    makeSafeFilename,
}
